import { motion } from "framer-motion";
import { LLMModelCard } from "./LLMModelCard";
import { useLLMDialog, useLLMSelection } from "../hooks";
import { useTranslation } from "react-i18next";

export const LLMModelGrid = () => {
  const { t } = useTranslation();
  const { visibleModels, isLoading, filteredCount, selectModel } =
    useLLMDialog();

  const { selectedModel } = useLLMSelection();

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {Array.from({ length: 8 }).map((_, index) => (
          <div
            key={index}
            className="h-48 bg-gray-200 dark:bg-gray-700 rounded-xl animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (filteredCount === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-muted-foreground">
          <p className="text-lg font-medium mb-2">
            {t("llmSelection.noModelsFound")}
          </p>
          <p className="text-sm">{t("llmSelection.tryDifferentSearch")}</p>
        </div>
      </div>
    );
  }

  return (
    <motion.div
      className="flex flex-col gap-3 sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 sm:gap-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      {visibleModels.map((model, index) => (
        <motion.div
          key={model._id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: index * 0.05 }}
          className="h-full"
        >
          {/* Mobile: Kompakt horizontal card, Desktop: Normal vertical card */}
          <div className="sm:hidden">
            <LLMModelCard
              model={model}
              isSelected={selectedModel?._id === model._id}
              onSelect={selectModel}
              isMobileCompact={true}
            />
          </div>
          <div className="hidden sm:block h-full">
            <LLMModelCard
              model={model}
              isSelected={selectedModel?._id === model._id}
              onSelect={selectModel}
            />
          </div>
        </motion.div>
      ))}
    </motion.div>
  );
};
